import { Box, Button, Grid, Input, MenuItem, Select } from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'

export const BoxLanguage = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: 56,
  top: 56,
  zIndex: 10,
  display: 'flex',
  [theme.breakpoints.down('sm')]: {
    right: 32,
    top: 30
  }
}))

export const ButtonHelp = styled(Button)(({ theme }) => ({
  minWidth: 'fit-content',
  borderRadius: '50%',
  position: 'relative',
  top: '3px',
  right: '19px',
  '&:active, &:hover': {
    backgroundColor: theme.palette.common.white,
    '& svg': {
      color: theme.palette.info.main
    }
  }
}))

export const SelectLanguage = styled(Select)(({ theme }) => ({
  background: theme.palette.common.white,
  boxShadow: '0px 8px 25px 0px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  padding: '8px 16px',
  color: theme.palette.primary.light,
  fontSize: theme.typography.body1.fontSize,
  maxHeight: '40px',
  '& .MuiSelect-select:focus': {
    backgroundColor: theme.palette.common.white
  },
  '& .MuiSelect-select.MuiSelect-select': {
    display: 'flex',
    alignItems: 'center'
  },
  '& svg': {
    color: theme.palette.primary.light,
    marginRight: '8px'
  },
  [theme.breakpoints.down('sm')]: {
    '& .MuiSelect-select.MuiSelect-select': {
      paddingTop: 4,
      paddingBottom: 4,
      fontSize: theme.typography.body1.fontSize
    },
    maxHeight: 40,
    fontSize: theme.typography.body2.fontSize
  },
  '&.dark': {
    boxShadow: '0px 2px 10px 4px rgb(37 41 45)',
    background: theme.palette.grey[900]
  }
}))

export const ItemOptionLanguage = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.grey[400],
  '& svg': {
    display: 'none'
  }
}))

export const WarningBox = styled(Box)(({ theme }) => ({
  background: '#062f87',
  position: 'relative',
  color: 'white',
  borderRadius: '16px',
  padding: '12px 20px',
  '&.seminar img': {
    display: 'none'
  },
  '& p': {
    fontWeight: 500,
    fontSize: '17px',
    marginBottom: '-6px'
  },
  '& img': {
    position: 'absolute',
    width: '250px',
    height: 'auto',
    top: '-32px',
    right: '-146px'
  },
  [theme.breakpoints.down('sm')]: {
    '& img': {
      display: 'none'
    }
  }
}))

export const GridForm = styled('form')(({ theme }) => ({
  maxWidth: 442,
  width: '100%',
  marginTop: '15vh',
  marginBottom: 64,
  paddingLeft: 24,
  paddingRight: 24,
  '&.live': {
    marginTop: 0
  },
  '&.seminar': {
    marginTop: 0,
    marginBottom: 0
  },
  '& .Mui-error': {
    borderColor: theme.palette.warning.main,
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.main
  },
  '& p.Mui-error': {
    backgroundColor: theme.palette.common.white
  },
  [theme.breakpoints.down('sm')]: {
    width: '90%',
    margin: '100px auto 20px',
    padding: 0,
    '& p, span': {
      fontSize: theme.typography.body2.fontSize
    },
    '& .MuiInputBase-root': {
      fontSize: theme.typography.body2.fontSize,
      maxHeight: 40
    }
  }
}))

export const Container = styled(Grid)(({ theme }) => ({
  minHeight: '88vh',
  justifyContent: 'center',
  alignContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    minHeight: 'auto',
    width: '100% !important'
  },
  '&.seminar': {
    minHeight: 'auto'
  }
}))

export const StyledInput = styled(Input)(({ theme }) => ({
  '&.Mui-disabled': {
    color: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[100]
  }
}))

export const FormBody = styled(Grid)(({ theme }) => ({
  width: '100% !important',
  [theme.breakpoints.down('sm')]: {
    width: 'auto !important',
    '& .MuiGrid-item': {
      padding: 8
    }
  }
}))

export const useLoginRegisterStyles = () => {
  const theme = useTheme()
  return {
    blockLanguage: {
      position: 'absolute',
      right: 56,
      top: 56,
      zIndex: 10,
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        right: 32,
        top: 30
      }
    },
    inputLanguage: {
      background: theme.palette.common.white,
      boxShadow: '0px 8px 25px 0px rgba(0, 0, 0, 0.1)',
      borderRadius: '8px',
      padding: '8px 16px',
      color: theme.palette.primary.light,
      fontSize: theme.typography.body1.fontSize,
      maxHeight: '40px',
      '& .MuiSelect-select:focus': {
        backgroundColor: theme.palette.common.white
      },
      '& .MuiSelect-select.MuiSelect-select': {
        display: 'flex',
        alignItems: 'center'
      },
      '& svg': {
        color: theme.palette.primary.light,
        marginRight: '8px'
      },
      [theme.breakpoints.down('sm')]: {
        '& .MuiSelect-select.MuiSelect-select': {
          paddingTop: 4,
          paddingBottom: 4,
          fontSize: theme.typography.body1.fontSize
        },
        maxHeight: 40,
        fontSize: theme.typography.body2.fontSize
      },
      '&.dark': {
        boxShadow: '0px 2px 10px 4px rgb(37 41 45)',
        background: theme.palette.grey[900]
      }
    },
    translateIcon: {
      [theme.breakpoints.down('sm')]: {
        display: 'none'
      }
    },
    optionLanguage: {
      color: theme.palette.grey[400],
      '& svg': {
        display: 'none'
      }
    },
    container: {
      minHeight: '88vh',
      justifyContent: 'center',
      alignContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        minHeight: 'auto',
        width: '100% !important'
      },
      '&.seminar': {
        minHeight: 'auto'
      }
    },
    link: {
      color: import.meta.env.VITE_COLOR_PRIMARY_MAIN || '#FC3E6F',
      fontSize: '12px'
    },
    form: {
      maxWidth: '442px',
      width: '100%',
      marginTop: '15vh',
      marginBottom: '64px',
      paddingLeft: '24px',
      paddingRight: '24px',
      '&live': {
        marginTop: '0'
      },
      '&.seminar': {
        marginBottom: '0',
        marginTop: '0'
      },
      '& .Mui-error': {
        borderColor: theme.palette.warning.main,
        backgroundColor: theme.palette.warning.light,
        color: theme.palette.warning.main
      },
      '& p.Mui-error': {
        backgroundColor: theme.palette.common.white
      },
      [theme.breakpoints.down('sm')]: {
        width: '90%',
        margin: '100px auto 20px',
        padding: 0,
        '& p, span': {
          fontSize: theme.typography.body2.fontSize
        },
        '& .MuiInputBase-root': {
          fontSize: theme.typography.body2.fontSize,
          maxHeight: 40
        }
      }
    },
    registerForm: {
      maxWidth: '560px',
      width: '100%',
      marginTop: '15vh',
      marginBottom: '64px',
      paddingLeft: '24px',
      paddingRight: '24px',
      '&.seminar': {
        marginTop: '0'
      },
      '& .Mui-error': {
        borderColor: theme.palette.warning.main,
        backgroundColor: theme.palette.warning.light,
        color: theme.palette.warning.main
      },
      '& p.Mui-error': {
        backgroundColor: theme.palette.common.white
      },
      [theme.breakpoints.down('sm')]: {
        width: '90%',
        margin: '0px auto 20px',
        padding: 0
      }
    },
    disabledInput: {
      color: theme.palette.grey[400],
      backgroundColor: theme.palette.grey[100]
    },
    formBody: {
      width: '100% !important',
      [theme.breakpoints.down('sm')]: {
        width: 'auto !important',
        '& .MuiGrid-item': {
          padding: 8
        }
      }
    },
    autocomplete: {
      '& input': {
        position: 'relative',
        bottom: 5
      }
    },
    registerBtn: {
      padding: '9px 16px',
      borderColor: theme.palette.primary.main,
      border: '1px solid',
      margin: 0,
      color: theme.palette.primary.main,
      '&:hover': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.dark
      }
    },
    registerLogoContent: {
      [theme.breakpoints.down('sm')]: {
        margin: 0,
        marginBottom: 40,
        marginTop: 35,
        marginLeft: 32
      }
    },
    registerLogo: {
      [theme.breakpoints.down('sm')]: {
        height: 20
      }
    },
    registerHeroTitle: {
      fontWeight: 700,
      '&live': {
        paddingBottom: 16,
        paddingLeft: 16,
        borderLeft: `4px solid ${theme.palette.primary.main}`
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.h6.fontSize
      }
    },
    stepper: {
      '&.MuiStepIcon-root': {
        color: theme.palette.primary.light
      },
      [theme.breakpoints.down('sm')]: {
        padding: 16,
        paddingBottom: 8
      }
    },
    warning: {
      background: '#062f87',
      position: 'relative',
      color: 'white',
      borderRadius: '16px',
      padding: '12px 20px',
      '&.seminar': {
        '& > img': {
          display: 'none'
        }
      },
      '& p': {
        fontWeight: '500',
        fontSize: '17px',
        marginBottom: '-6px'
      },
      '& img': {
        position: 'absolute',
        width: '250px',
        height: 'auto',
        top: '-32px',
        right: '-146px'
      },
      [theme.breakpoints.down('sm')]: {
        '& img': {
          display: 'none'
        }
      }
    },
    list: {
      '& li': {
        fontSize: '15px',
        marginBottom: '-17px'
      },
      '& li span': {
        fontSize: '15px'
      }
    },
    buttonHelp: {
      minWidth: 'fit-content',
      borderRadius: '50%',
      position: 'relative',
      top: '3px',
      right: '19px',
      '&:active, &:hover': {
        backgroundColor: theme.palette.common.white,
        '& svg': {
          color: theme.palette.info.main
        }
      }
    }
  }
}
